import { Accessor, Setter, createSignal, createContext, Signal } from 'solid-js';
import { requireContext } from 'common';

export class SortableContext<T> {
    items: Accessor<T[]>;
    setItems: Setter<T[]>;

    draggedIndex: Accessor<number | undefined>;
    setDraggedIndex: Setter<number | undefined>;

    dropIndex: Accessor<number | undefined>;
    setDropIndex: Setter<number | undefined>;

    dropPosition: Accessor<'above' | 'below' | undefined>;
    setDropPosition: Setter<'above' | 'below' | undefined>;

    onReorder?: (items: T[], fromIndex: number, toIndex: number) => void;

    constructor(itemsSignal: Signal<T[]>) {
        [this.items, this.setItems] = itemsSignal;
        [this.draggedIndex, this.setDraggedIndex] = createSignal<number | undefined>();
        [this.dropIndex, this.setDropIndex] = createSignal<number | undefined>();
        [this.dropPosition, this.setDropPosition] = createSignal<'above' | 'below' | undefined>();
    }

    moveItem(fromIndex: number, toIndex: number) {
        const currentItems = this.items();
        const newItems = [...currentItems];

        // Remove item from old position
        const [movedItem] = newItems.splice(fromIndex, 1);

        // Adjust toIndex if moving down
        const adjustedToIndex = fromIndex < toIndex ? toIndex - 1 : toIndex;

        // Insert at new position
        newItems.splice(adjustedToIndex, 0, movedItem);

        this.setItems(newItems);
        this.onReorder?.(newItems, fromIndex, adjustedToIndex);

        return newItems;
    }
}

export const SortableContextJsx = createContext<SortableContext<any>>();

export function requireSortableContext<T>() {
    return requireContext(SortableContextJsx) as SortableContext<T>;
}
